export default __webpack_public_path__ + "static/media/prt_temp.4ec46447.jpg";